import React from 'react';
import Box from '@mui/material/Box';

const HighlightText = ({ text, query, sx = {} }) => {
    if (!query || !text) {
        return <Box component="span" sx={sx}>{text}</Box>;
    }

    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    const parts = text.split(regex);

    if (parts.length === 1) {
        return <Box component="span" sx={sx}>{text}</Box>;
    }

    return (
        <Box component="span" sx={sx}>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <Box
                        key={index}
                        component="span"
                        sx={{
                            background: 'rgba(20, 141, 253, 0.10)',
                            borderRadius: '2px',
                            px: '1px',
                        }}
                    >
                        {part}
                    </Box>
                ) : (
                    <React.Fragment key={index}>{part}</React.Fragment>
                )
            )}
        </Box>
    );
};

export default HighlightText;
